import LegalDocument from "../legal-document";
import content from "./content";

export default function PrivacyPolicy() {
  return (
    <LegalDocument
      content={content}
      documentTitle="Chính sách quyền riêng tư"
      kicker="Bảo vệ dữ liệu cá nhân"
    />
  );
}
